import React from 'react';
import '../../styles/RateCard.css';

const VideoBanners = () => {
    return (
        <section className="video-banners-section py-5">
            <div className="container">
                <div className="row gx-5 align-items-center">

                    {/* Columna Izquierda */}
                    <div className="col-md-6 bg-dark-teal text-white p-5 rounded-start" data-aos="fade-right" data-aos-delay="200">
                        <h2 className="title text-white text-capitalize">
                            Video<br /><span className="highlight-bg">Banners</span>
                        </h2>
                        <p className="mt-4">
                            Los video banners de BeHealth son una solución dinámica y envolvente para transmitir 
                            mensajes de alto impacto. Este formato combina creatividad visual con un enfoque estratégico, 
                            capturando la atención del público en momentos clave y reforzando el posicionamiento de tu marca 
                            en un entorno digital premium. Especialmente recomendado para storytelling y campañas de branding.
                        </p>
                        <ul className="mt-4 custom-bullets">
                            <li>Formato que incrementa la atención del usuario.</li>
                            <li>Ubicación en posiciones y contenidos estratégicas para maximizar la visibilidad.</li>
                            <li>Compatible con dispositivos desktop y mobile, asegurando cobertura total.</li>
                            <li>Resultados medibles con métricas detalladas al finalizar la campaña.</li>
                        </ul>
                        <div className="tab-label mt-4">Banners</div>
                    </div>

                    {/* Columna Derecha */}
                    <div className="col-md-6 bg-light-green p-5 rounded-end position-relative" data-aos="fade-left" data-aos-delay="200">

                        <div className='d-flex justify-content-center'>
                            <div className='position-relative z-0'>
                                <h3 className="subtitle-rate-card fw-bold text-center">Características</h3>

                                <div className='position-absolute top-100 start-50 translate-middle'>
                                    <svg width="2em" height="2em" viewBox="0 0 16 16" class="position-absolute top-100 start-50 translate-middle bi bi-caret-down-fill" fill="#439b6b" xmlns="http://www.w3.org/2000/svg"><path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" /></svg>
                                </div>
                            </div>
                        </div>
                        <div className='reach mt-3 rounded p-3'>
                            <h4>Tipo de contrato:</h4>
                            <p className="">
                                Fijo durante un período específico o x impresiones.
                            </p>
                        </div>
                        <div className="includes-box">
                            <div className='shadow-lg rounded p-4 mt-3'>
                                <h5 className="fw-bold text-teal">Incluye:</h5>
                                <ul className="ps-3 mt-2">
                                    <li>Video in-stream o out-stream (dentro o fuera del contenido principal).</li>
                                    <li>Opciones de targeting avanzado para audiencias específicas.</li>
                                    <li>Opciones multiplataforma (desktop y mobile).</li>
                                    <li>Reporte detallado de métricas al finalizar la campaña.</li>
                                </ul>
                            </div>
                        </div>

                        <div className='w-100 d-flex justify-content-center'>
                            <div className="investment-box bg-teal text-white p-3 mt-4 rounded shadow-lg">
                                <strong>Inversión:</strong><br />
                                A cotizar
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default VideoBanners;
